import React from "react";
import "./Styles/miniheader.css"

export const Miniheader=(props)=>{
return(
    <button className="flexcenter">
        {
            props.icon ?
            <props.img sx={{fontSize: '18px'}} />:
            <img src={ props.img} alt="image1"/>
        }
        <span> {props.label}</span>
    </button>
)
}